import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { usePlatformAuthStore } from '../lib/platformAuthStore.js';

export function RequirePlatformAuth({ children }: { children: ReactNode }): JSX.Element {
  const token = usePlatformAuthStore((s) => s.accessToken);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/platform/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
